export const securityCodeForm = [
    {
        cols: [
            {
                formGroup: 'securityCodeForm',
                class: 'col-12 col-lg-8',
                title: 'Insertar Código seguridad',
                titleClass: 'form-title text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-12 col-lg-8',
                subtitle: 'Introduce el código que te hemos enviado al email con el que accedes al Área de Clientes',
                subtitleClass: 'form-subtitle text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-10 col-lg-6 mx-auto',
                item: 'input',
                type: 'text',
                placeholder: 'Código',
                inputClass: 'text-input',
                formControlName: 'code',
                required: true
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-10 col-md-5 col-lg-3',
                item: 'button',
                type: 'regular',
                placeholder: 'Volver a enviar código',
                inputClass: 'form-button btn btn-primary mb-3',
                buttonAction: 'forgotPassword'
            },
            {
                class: 'col-10 col-md-5 col-lg-3',
                item: 'button',
                type: 'regular',
                placeholder: 'Validar',
                inputClass: 'form-button btn btn-primary',
                buttonAction: 'onSubmit'
            }
        ]
    }
]

